import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  ActivityStatusEnum,
  OrganizationInterface,
} from '@sport-activities/sdk';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';

import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';
import { SuccessStatusEnum } from '~/core/enums/success-status.enum';
import { isQueryParamTruthy } from '~/core/helpers/query-params/truthy/truthy.helper';
import { Activity } from '~/core/model/activity.model';
import { RedirectionService } from '~/core/services/redirection/redirection.service';
import { TitleService } from '~/core/services/title/title.service';
import { organizerSharedConfig } from '~/organizer/shared/configs/config';
import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';
import { OrganizerSharedOrganizationService } from '~/organizer/shared/services/organization/organization.service';

@Component({
  selector: 'app-organizer-activity-creation-preview',
  templateUrl: './preview.component.html',
})
export class OrganizerActivityCreationPagePreviewComponent implements OnInit {
  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;

  public showSuccess = false;
  public successStatus = SuccessStatusEnum.SUCCESS;
  public organizationReviewsStats = {
    averageRating: 0,
    count: 0,
  };

  constructor(
    private readonly redirectionService: RedirectionService,
    private readonly activityService: OrganizerSharedActivityService,
    private readonly organizationService: OrganizerSharedOrganizationService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly titleService: TitleService,
    private readonly translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.titleService.setPageTitle(
      'seo.organizer.activity_creation.preview.title'
    );
  }

  public get activity(): Activity {
    return this.activityService.activity;
  }

  public get organization(): OrganizationInterface {
    return this.organizationService.organization;
  }

  public get successLabels(): {
    action: string;
    description: string;
    title: string;
  } {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const { activityEdition } = organizerSharedConfig.queryParams;
    if (isQueryParamTruthy(queryParams[activityEdition])) {
      return {
        title: this.translateService.instant('activity_edition.success.title'),
        description: this.translateService.instant(
          'activity_edition.success.description'
        ),
        action: this.translateService.instant(
          'activity_edition.success.button.validate'
        ),
      };
    }
    return {
      title: this.translateService.instant('activity_creation.success.title'),
      description: this.translateService.instant(
        'activity_creation.success.description'
      ),
      action: this.translateService.instant(
        'activity_creation.success.button.validate'
      ),
    };
  }

  public clickNextNavigationButtons(): Promise<boolean> {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const { activityEdition, from } = organizerSharedConfig.queryParams;

    if (isQueryParamTruthy(queryParams[activityEdition])) {
      const url = queryParams[from];

      if (url.includes('?')) {
        return this.router.navigateByUrl(`${url}&updated=true`);
      }

      return this.router.navigateByUrl(`${url}?updated=true`);
    }

    if (
      queryParams?.activityId &&
      this.activity.status &&
      this.activity.status !== ('DRAFT' as ActivityStatusEnum)
    ) {
      return this.redirectionService.redirect('organizer.planning.planning');
    }

    return this.redirectionService.redirect(
      'organizer.activity-planning.steps-2',
      { queryParams: { activityId: queryParams?.activityId } }
    );
  }

  public toggleShowSuccess(): void {
    this.showSuccess = !this.showSuccess;
  }
}
